import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    // @ts-expect-error Prop exists
    marginLeft: ({ smallMedia }) => (smallMedia ? '0' : '0.25rem')
  },

  icon: {
    marginTop: '0.125rem',
    fontSize: theme.size.base,
    color: theme.palette.primary.main,
    cursor: 'pointer',
    transform: 'rotate(90deg)'
  },

  menuItem: {
    display: 'flex',
    margin: '0.5rem 0.25rem',
    cursor: 'pointer',
    fontSize: theme.size.sm
  },

  menuIcon: {
    marginRight: '0.625rem',
    fontSize: theme.size.base,
    color: theme.palette.primary.main
  }
}))

export default useStyles
